import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../share/services/local-storage.service';
import { NavigationService } from '../share/services/navigation.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,
        private localStorageService: LocalStorageService,
        private navigationService: NavigationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.localStorageService.isLogged()) {
            return true
        }
        this.router.navigate(['/login'], {
            queryParams: {
              return: state.url
            }
        });
        return false;
        //this.navigationService.goToLogin();
        //return false;
    }
}
